import axios from "axios";
import { useHistory } from "react-router-dom"; // useHistory for v5
import { toast } from "react-toastify";
import { API_BASE_URL } from "../config";

const useLogout = () => {
    const history = useHistory(); // useHistory hook for navigation

    const logout = async () => {
        await axios
            .post(`${API_BASE_URL}/logout`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("authToken")}`,
                },
            })
            .then(function (response) {
                localStorage.removeItem("authToken");
                toast.success(response.data.message);
                history.push("/login"); // use history.push to navigate in v5
            })
            .catch(function (error) {
                if (error.response.status === 401) {
                    localStorage.removeItem("authToken");
                    history.push("/login");
                }
                // toast.error('Logout Successfully!');
                toast.success('Logout Successfully', {
                    position: "bottom-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",

                });
            });
    };

    return logout;
};

export default useLogout;
